import { BrowserRouter } from 'react-router-dom'
import AppMenu from './appMenu'
import MoovyRouters from './moovyRouters'
import SystemStatusBanner from './systemStatus/systemStatusBanner'

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AppMenu>
        <SystemStatusBanner sx={{ marginTop: 4 }} />
        <MoovyRouters />
      </AppMenu>
    </BrowserRouter>
  )
}

export default AppRoutes
